import Toast from '@/components/new/common/toast/Toast.vue'
const MyToast = {}
MyToast.install = function (Vue) {
  const ToastConstructor = Vue.extend(Toast)
  const instance = new ToastConstructor()
  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
  Vue.prototype.$toast = (icon, msg) => {
    instance.icon = icon
    instance.msg = msg
    instance.isShow = true
    setTimeout(() => {
      instance.isShow = false
    }, 1500)
  }
}

export default MyToast
